// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 874 ? "ui-libs" : chunkId) + "." + {"3":"c528caed","137":"b1e8582e","274":"d2ea3bfa","305":"bdf907fc","328":"e1aadf48","358":"f0afec59","572":"64bf85f0","657":"6a33b38f","692":"b4e78c9a","743":"992a5931","869":"c3ad6e7f","874":"523919b6","953":"1a1541c5"}[chunkId] + ".chunk.js";
};